// AWS configuration — populated after CDK deploy
// Update these values from CDK stack outputs
export const awsConfig = {
  region: 'us-east-1',
  cognito: {
    userPoolId: process.env.REACT_APP_USER_POOL_ID || 'us-east-1_WcNbjuTw0',
    userPoolClientId: process.env.REACT_APP_USER_POOL_CLIENT_ID || 'v1r1l4ol4kamh3efdm7mltohc',
  },
  api: {
    endpoint: process.env.REACT_APP_API_URL || 'https://ebjwatwjk3.execute-api.us-east-1.amazonaws.com/prod',
  },
};
